<div class="back-button">
  <p-button
    [pTooltip]="'Back' | translate"
    (click)="goBack()"
    icon="pi pi-arrow-left"
    [rounded]="true"
    [text]="true"
  ></p-button>

  <h2 class="">{{ $any(title) | translate }}</h2>


<!--  <p-progressSpinner-->
<!--    *ngIf="loading"-->
<!--    [style]="{width: '30px', height: '30px'}"-->
<!--    strokeWidth="4"-->
<!--  >-->
<!--  </p-progressSpinner>-->
</div>
<div class="subtitle">
  {{subtitle}}
</div>
